import type { CSSObject } from '@emotion/react';

export const BILLING_DATA_GRID_CLASS_NAME = 'billing-data-grid';

export const billingDataGridStyles = {
  [`.${BILLING_DATA_GRID_CLASS_NAME} .mrt-table-head-cell-content`]: {
    // MRT's 100% height centers labels in cells without a filter underneath.
    height: 'auto',
    flexShrink: 0,
  },
} satisfies CSSObject;
